const { getElement, getElements } = window.BAO.Utils

class SiteDrawers extends window.BAO.CustomElement() {
  constructor () {
    super()

    if (this.hasAlreadyBeenUsed) {
      throw new Error(
        `You can only use 1 instance of ${this.nodeName.toLowerCase()}`,
      )
    }

    this._activeDrawerKey = ''
    this.drawers = []
    this.activeTriggers = []

    window.drawers = this

    this.drawerKeys
      .filter((key) => !this.triggerKeys.includes(key))
      .forEach((key) =>
        console.info(`Drawer exists for ${key} but there is no trigger`),
      )
  }

  setupListeners () {
    super.setupListeners()

    this.listeners.add(
      document.documentElement,
      'click',
      this.handleClick.bind(this),
    )

    this.listeners.add(document, 'keyup', this.handleKeyUp.bind(this))
  }

  handleClick (e) {
    const targetEl =
      e.target.closest(this.config.matches.trigger) ||
      e.target.closest(this.config.matches.back) ||
      e.target.closest(this.config.matches.close) ||
      e.target.closest(this.config.matches.backdrop)

    if (
      targetEl?.hasAttribute('aria-disabled') &&
      targetEl.getAttribute('aria-disabled') !== 'false'
    ) {
      e.preventDefault()
      return
    }

    const EVENTS = {
      TRIGGER: 'TRIGGER',
      BACK: 'BACK',
      CLOSE: 'CLOSE',
      BACKDROP: 'BACKDROP',
      UNKNOWN: 'UNKNOWN',
    }
    const eventType = (() => {
      if (e.target.closest(this.config.matches.trigger) !== null) {
        return EVENTS.TRIGGER
      } else if (e.target.closest(this.config.matches.back) !== null) {
        return EVENTS.BACK
      } else if (e.target.closest(this.config.matches.close) !== null) {
        return EVENTS.CLOSE
      } else if (e.target.closest(this.config.matches.backdrop) !== null) {
        return EVENTS.BACKDROP
      }

      return EVENTS.UNKNOWN
    })()

    if (eventType === EVENTS.UNKNOWN) return
    e.preventDefault()

    if (eventType === EVENTS.TRIGGER) {
      const trigger = e.target.closest(this.config.matches.trigger)
      const key = trigger.getAttribute('data-drawers-trigger')

      this.activeTriggers.push(trigger)

      this.isSubDrawerTrigger = e.target.closest(this.config.matches.subNav)

      if (this.triggerKeys.includes(key)) {
        if (this.isSubDrawerTrigger) {
          this.parentDrawerKey = !this.parentDrawerKey
            ? this.activeDrawerKey
            : this.parentDrawerKey
          this.activeDrawerKey = key
        } else {
          this.activeDrawerKey =
            key === this.activeDrawerKey || key === this.parentDrawerKey
              ? ''
              : key
          this.parentDrawerKey = ''
        }
      }

      this.getParentDrawers(trigger).forEach((parentDrawer) => {
        parentDrawer.isOpen = true
      })

      if (this.activeDrawerKey === 'cart') {
        window.dataLayer.push({
          event: 'view_cart_flyout',
          anocus_shop_language: window.BAO.dataLayer.shopLanguage,
          anocus_shop_country: window.BAO.dataLayer.shopCountry,
          cart: {
            currency: window.BAO.dataLayer.cartCurrency,
            value: window.BAO.dataLayer.cartValue,
            items: window.BAO.dataLayer.items,
          },
        })
      }
    }

    if (eventType === EVENTS.BACK) {
      const backButton = e.target.closest(this.config.matches.back)
      const drawersToKeepOpen = backButton.dataset.drawersParentKeys.split(',')

      this.drawers
        .filter((drawer) => !drawersToKeepOpen.includes(drawer.key))
        .forEach((drawer) => (drawer.isOpen = false))

      this.setExpanded([backButton.getAttribute('data-drawers-parent-keys')])
    }

    if (eventType === EVENTS.CLOSE || eventType === EVENTS.BACKDROP) {
      this.closeDrawer()
    }
  }

  handleKeyUp (event) {
    const KEYCODE_ESCAPE = 27

    /* Close drawers when escaping */
    if (
      event.code?.toUpperCase() === 'ESCAPE' ||
      event.keyCode === KEYCODE_ESCAPE
    ) {
      this.closeDrawer()
    }
  }

  closeDrawer () {
    const currentDrawerKey = this.activeDrawerKey

    this.isSubDrawerTrigger = false
    this.parentDrawerKey = ''
    this.activeDrawerKey = ''

    this.dispatchEvent(
      new CustomEvent('site-modal:close', {
        bubbles: true,
        detail: { key: currentDrawerKey },
      }),
    )
  }

  /**
   * @param {string} key
   */
  open (key, triggerEl) {
    this.activeDrawerKey = key

    if (triggerEl) {
      this.activeTriggers.push(triggerEl)
    }
  }

  setExpanded (keys) {
    this.triggerKeys.forEach((triggerKey) => {
      const triggerEl = getElement(`[data-drawers-trigger='${triggerKey}']`, {
        context: document,
      })
      if (!triggerEl) return
      triggerEl.setAttribute(
        'aria-expanded',
        String(keys.includes(triggerKey)),
      )
    })
  }

  set parentDrawerKey (key) {
    this._parentDrawerKey = key
  }

  get parentDrawerKey () {
    return this._parentDrawerKey?.length
      ? this._parentDrawerKey
      : this.activeDrawerKey
  }

  get triggerKeys () {
    return getElements('[data-drawers-trigger]').map((el) =>
      el.getAttribute('data-drawers-trigger'),
    )
  }

  get drawerKeys () {
    return getElements('[data-module-drawers-drawer]').map((el) =>
      el.getAttribute('data-module-drawers-drawer'),
    )
  }

  get hasAlreadyBeenUsed () {
    const el = getElement(this.nodeName.toLowerCase())

    return el !== this
  }

  get aDrawerIsOpen () {
    return this.drawers.some((drawer) => drawer.isOpen)
  }

  get activeDrawerKey () {
    return this._activeDrawerKey
  }

  set activeDrawerKey (key) {
    this._activeDrawerKey = key

    this.drawers.forEach((drawer) => (drawer.isOpen = drawer.key === key))

    this.setExpanded([this.parentDrawerKey, key])

    if (key !== 'search') {
      /* Remove the search class from body when new active key is set */
      /* Delay removal when key is blank otherwise header will be hidden behind search */
      setTimeout(
        () => {
          document.body.classList.remove('drw-Drawers-search')
        },
        key === '' ? 500 : 0,
      )
    }

    this.config.elements.drawers.classList.toggle(
      this.config.classes.activeClass,
      this.aDrawerIsOpen,
    )
    document.body.classList.toggle(
      this.config.classes.siteOverflowed,
      this.aDrawerIsOpen,
    )
    document.body.classList.toggle(
      this.config.classes.drawersOpenUtility,
      this.aDrawerIsOpen,
    )

    if (key !== '') {
      this.els.drawer.element.classList.add('drw-Drawers_Drawer-active')
      document.body.classList.add(`drw-Drawers-${key}`)
    } else {
      this.els.drawer.element.classList.remove('drw-Drawers_Drawer-active')
    }
  }

  getParentDrawers (trigger) {
    const drawerKeys = trigger.dataset.drawersParentKeys
      ? trigger.dataset.drawersParentKeys.split(',')
      : []
    return drawerKeys.map((drawerKey) => {
      return getElement(`[key="${drawerKey}"]`, {
        context: this,
      })
    })
  }

  get config () {
    return {
      matches: {
        trigger: '[data-drawers-trigger]',
        subNav: '[data-drawers-sub-nav]',
        back: '[data-drawers-back]',
        close: '[data-drawers-close]',
        backdrop: '[data-site-drawers-el="backdrop"]',
      },
      classes: {
        activeClass: 'drw-Drawers-active',
        activeDrawerClass: 'drw-Drawer-active',
        siteOverflowed: 'util-SiteOverflowed',
        drawersOpenUtility: 'util-DrawersOpen',
      },
      elements: {
        body: document.body || document.documentElement,
        backdrop: '[data-site-drawers-el="backdrop"]',
        drawers: document.querySelector('site-drawers'),
      },
    }
  }
}

if (!customElements.get('site-drawers')) {
  customElements.define('site-drawers', SiteDrawers)
}
